import React, { useState } from 'react'
import DispatchNavCard from './DispatchNavCard'
import Styles from './Styles.module.css'
import SelectDropdown from '../../../../Components/Dropdown/SelectDropdown'
import { DeliveryManApis } from '../../../../App/api/delivery.apis'
import { useEffect } from 'react'
import CommonLayout from '../../../../Components/CommonLayout/CommonLayout'

function DispatchPage({meta}) {
  const [allDeliveryMan,setAllDeliveryMan]=useState("")

  const [deliveryStatus,setDeliveryStatus]=useState({
    filter: {
          "availability.status": ""
        },
        "page": 1,
        "limit": 10,
        "sortOrder": "desc"
  })
  const fetchAllDeliveryMan=async()=>{
    try{
      const res= await DeliveryManApis.getAllDeliveryMan(deliveryStatus);
    setAllDeliveryMan(res?.data?.data);
    
    }catch(error){     
      console.log("error:",error);
      
    }
  }
  console.log("all Delivery Man",allDeliveryMan);
  const [leftTabs, setLeftTabs] = useState([
    {
      tab: "New",
      isActive: true,
    },
    {
      tab: "Assigned",
      isActive: false
    },
    {
      tab: "On Delivery",
      isActive: false
    },
  ])
  const [rightTabs, setRightTabs] = useState([
    {
      tab: "Free",
      isActive: false,
    },
    {
      tab: "On Job",
      isActive: false
    },
    {
      tab: "Offline",
      isActive: false
    },
  ])
  useEffect(()=>{
    fetchAllDeliveryMan();
    },[])
  return (
    <div className={[`${Styles.dispatchContainer}`]}>
      <div className="left">
        <DispatchNavCard tabs={leftTabs} allDeliveryMan={allDeliveryMan} setDeliveryStatus={setDeliveryStatus} fetchAllDeliveryMan={fetchAllDeliveryMan} setTab={setLeftTabs} sx={{ borderTopRightRadius: "10px" }} />
      </div>
      <div className={Styles.center}>
      <div className="flex justify-between">
      <CommonLayout/>
        <div className={`${Styles.filter}`}>
       <p className={Styles.filterLabel}>Filter: </p><SelectDropdown sx={{width:"13rem", height:"2.5rem", borderRadius:"3px", border: "1px solid var(--boder-color)"}} inputName="dispatch_filter" placeholder="" options={[{name:"Store",code:"Store"},{name:"Courier",code:"Courier"},]} handleFilter={(v)=>{console.log("v",v);}}/>
        </div>
      </div>
        <div class={Styles.mapContainer}>
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14789.971272134948!2d82.1453587!3d22.0689886!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a280bbf02dd0d65%3A0x7024a8e995e4bd2a!2sNable%20Invent%20Solution%20(INDIA)!5e0!3m2!1sen!2sin!4v1717753795392!5m2!1sen!2sin" width="100%" height="100%" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
      {/* <div className="right">
        <DispatchNavCard tabs={rightTabs} setTab={setRightTabs} sx={{ borderTopLeftRadius: "10px" }} />
      </div> */}
    </div>
  )
}

export default DispatchPage